module.exports = __webpack_public_path__ + "img/order5.de5a59b5.svg";